export default __webpack_public_path__ + "static/media/storm.9548c88b.svg";